module.exports = __webpack_public_path__ + "static/media/logo-white.f4dabc12.png";